import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useSettings } from '../contexts/SettingsContext';

const FilterBar = () => {
    const { pathname } = useLocation();
    const [searchParams] = useSearchParams();
    const { mediaVolume, setMediaVolume, cardSize, setCardSize } = useSettings();
    const currentType = searchParams.get('type');
    const filters = [
        { label: 'All', type: '' },
        { label: 'Images', type: 'image/*' },
        { label: 'Videos', type: 'video/*' },
        { label: 'Audio', type: 'audio/*' },
    ];

    const filterTo = (type) => {
        const params = new URLSearchParams(searchParams);
        params.delete('before');
        params.delete('after');
        if (type) params.set('type', type);
        else params.delete('type');
        return { pathname, search: params.toString() };
    };

    return (
        <div className="border-b border-gray-200 bg-white/95 backdrop-blur">
            <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-x-6 gap-y-3 px-4 py-3">
                <nav aria-label="ファイルの種類" className="flex items-center gap-1">
                    {filters.map(filter => {
                        const active = filter.type ? currentType?.split('/')[0] === filter.type.split('/')[0] : !currentType;
                        return (
                            <Link
                                key={filter.label}
                                to={filterTo(filter.type)}
                                aria-current={active ? 'page' : undefined}
                                className={'rounded-full px-3 py-1.5 text-sm font-medium whitespace-nowrap transition-colors ' + (
                                    active ? 'bg-blue-100 text-blue-700' : 'text-gray-500 hover:text-gray-700 hover:bg-gray-100'
                                )}
                            >
                                {filter.label}
                            </Link>
                        );
                    })}
                </nav>
                <div className="flex flex-wrap items-center gap-x-3 gap-y-3 text-xs sm:gap-x-5 text-gray-600">
                    <div className="flex items-center gap-2">
                        <label htmlFor="media-volume" className="whitespace-nowrap">共通音量</label>
                        <input id="media-volume" type="range" min="0" max="1" step="0.01" value={mediaVolume}
                            onChange={(event) => setMediaVolume(event.currentTarget.valueAsNumber)}
                            aria-valuetext={Math.round(mediaVolume * 100) + '%'}
                            className="w-20 cursor-pointer accent-blue-600 sm:w-28" />
                        <output htmlFor="media-volume" className="w-9 text-right tabular-nums">{Math.round(mediaVolume * 100)}%</output>
                    </div>
                    <label className="flex items-center gap-2">
                        <span className="whitespace-nowrap"><span className="hidden sm:inline">カード</span>サイズ</span>
                        <select aria-label="カードサイズ" value={cardSize} onChange={(event) => setCardSize(event.target.value)} className="rounded-lg border border-gray-200 bg-gray-50 px-2 py-1.5 text-gray-700 focus:outline-blue-600">
                            <option value="compact">コンパクト</option>
                            <option value="standard">標準</option>
                            <option value="large">大きめ</option>
                        </select>
                    </label>
                </div>
            </div>
        </div>
    );
};

export default FilterBar;
